import returnComponent from "@/components/navigation/ReturnToList.vue";
import TermsOfUseComponent from "@/components/terms/TermsOfUseComponent.vue";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "TermsOfUse",
  components: {
    return: returnComponent,
    TermsOfUseComponent: TermsOfUseComponent,
    BackgroundVideo: BackgroundVideo
  }
};